import { render, staticRenderFns } from "./form-stepper-admit.vue?vue&type=template&id=b3929016"
import script from "./form-stepper-admit.vue?vue&type=script&lang=js"
export * from "./form-stepper-admit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports